<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateEditCategoriaModal
      v-if="showCreateEditCategoriaModal"
      :categoriaId="categoriaIdSelected"
      @closeModal="closeCreateEditCategoriaModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Categorias de peças</h5>
        <div v-if="getModuleUserByCode('0.01.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Novo Usuário"
            @click="createEditCategoria()"
          >
            Nova Categoria
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListCategorias
          :categorias="categorias"
          @editCategoria="createEditCategoria"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import CreateEditCategoriaModal from '@/components/projeto/modelos/peca/CreateEditCategoriaModal.vue'
import ListCategorias from '../../../../components/projeto/modelos/peca/ListCategorias.vue'

export default {
  name: 'Categorias',

  components: {
    Layout,
    PageHeader,
    CreateEditCategoriaModal,
    LoadingData,
    ListCategorias,
  },

  data() {
    return {
      title: 'Categorias',
      items: [
        {
          text: 'Projeto',
        },
        {
          text: 'Modelos',
          active: true,
        },
        {
          text: 'Peça',
          active: true,
        },
        {
          text: 'Categorias',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditCategoriaModal: false,
      categorias: null,
      categoriaIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getCategorias() {
      try {
        this.categorias = await this.$store.dispatch('getCategorias')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditCategoria(categoriaId) {
      this.categoriaIdSelected = categoriaId || null
      this.showCreateEditCategoriaModal = true
    },

    closeCreateEditCategoriaModal(loadListCategorias) {
      if (loadListCategorias) {
        this.getCategorias()
      }
      this.showCreateEditCategoriaModal = false
    },
  },

  mounted() {
    this.getCategorias()
  },
}
</script>
